/*eslint-disable*/
import CurrentRetailersFailing from './SubPanelComponents/CurrentRetailersFailing';
import DateRangeSubComponent from './SubPanelComponents/DateRangeSubComponent';
import InspectionFailure from './SubPanelComponents/InspectionFailure';

export const SubPanel = ({ type, handleStateForm = () => {}, stateForm = {} }) => {
  switch (type) {
    case 'current_retailers_failing_inspection':
      return <CurrentRetailersFailing handleStateForm={handleStateForm} stateForm={stateForm} type={type} />;

    case 'retailers_failing':
    case 'retailers_passing':
      return <DateRangeSubComponent type={type} handleStateForm={handleStateForm} stateForm={stateForm} />;
    case 'inspection_failure_rate_by':
      return <InspectionFailure type={type} handleStateForm={handleStateForm} stateForm={stateForm} />;
    default:
      return <div style={{ fontSize: '14px', color: '#6b7280' }}>Additional options for {type}</div>;
  }
};
